// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setMasterData } from "_core/slices/datas/MasterSlice";
import { setApiTimestamp, setTransactionData, setIsDemo } from "_core/slices/datas/TransactionSlice";


const UsersReloadApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/users/reload";

    // API実行
    const ExecUsersReloadApi = async () => {
        // 必要なリクエストなし

        let response = null;
        let error = null;
    
        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url });
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
            dispatch(setIsDemo(response['is_demo']));
            dispatch(setTransactionData({
                tUser:response['t_user'],
                tUserAdd:response['t_user_add'],
                tAccount:response['t_account'],
                tAppearanceList:response['t_appearance_list'],
                tAssetList:response['t_asset_list'],
                tVoiceTypeList:response['t_voice_type_list'],
                iConstantList:response['i_constant_list'],
            }));
            dispatch(setMasterData({
                iConstantList:response['i_constant_list'],
            }));
        }
        return { response, error };
    };

    return ExecUsersReloadApi;
};

export default UsersReloadApi;